import { WarningCircleIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  DUNS_NOT_ON_SPA_FILTER_KEY,
  spaDunsFilterApplies,
} from './spaDunsFilter';

/**
 * Filter toggle: only claims whose DUNS no SPA active on the invoice date
 * names. Rendered only while the supplier filter is narrowed to suppliers with
 * the SPA DUNS check (Schneider) — see {@link spaDunsFilterApplies}.
 */
export function DunsNotOnSpaToggle({
  filters,
  suppliers,
  onChange,
}: {
  filters: Record<string, string[] | undefined>;
  suppliers: readonly { id: string; hasSpaDunsCheck?: boolean }[] | undefined;
  onChange: (key: string, values: string[] | undefined) => void;
}) {
  if (!spaDunsFilterApplies(filters.trading_partner, suppliers)) return null;
  const active = filters[DUNS_NOT_ON_SPA_FILTER_KEY]?.[0] === 'true';
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={active ? 'default' : 'outline'}
            size="sm"
            className="h-7 gap-1.5"
            aria-pressed={active}
            onClick={() =>
              onChange(
                DUNS_NOT_ON_SPA_FILTER_KEY,
                active ? undefined : ['true'],
              )
            }
          >
            <WarningCircleIcon className="h-3.5 w-3.5" />
            <T context="S&D transactions filter toggle: claims whose DUNS is not on an active SPA">
              DUNS Not on SPA
            </T>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <T context="tooltip for the DUNS-not-on-SPA filter toggle">
            Claims whose DUNS is not named by any SPA active on the invoice
            date. The supplier will likely reject these (code 1).
          </T>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
